import {
	useLazyCertificatesQuery,
	useLazyRootWorkplaceByChildQuery,
} from '../../../graphql/graphql';

export default function useCertificates() {
	const [loadCertificates] = useLazyCertificatesQuery();
	const [getRootWorkplace] = useLazyRootWorkplaceByChildQuery();

	const checkWorkplaceCertificateAvailability = async (
		workplaceId: string,
		certificateType: string,
	) => {
		const { workplace } = await getRootWorkplace({
			workplaceId,
		}).unwrap();

		const { certificates } = await loadCertificates({
			workplaceId: workplace?.rootWorkplace?.id || workplaceId,
			type: certificateType,
		}).unwrap();

		const certificate = certificates?.data?.find(
			({ type }: any) => type === certificateType,
		);

		return !!certificate;
	};

	const checkUserCertificateAvailability = async (
		userId: string,
		certificateType: string,
	) => {
		const { certificates } = await loadCertificates({
			userId,
			type: certificateType,
		}).unwrap();

		const certificate = certificates?.data?.find(
			({ type }: any) => type === certificateType,
		);

		return !!certificate;
	};

	return {
		checkUserCertificateAvailability,
		checkWorkplaceCertificateAvailability,
	};
}
